/**
 * Inclusions Table Animations
 * Animate table elements on scroll
 */

(function() {
    'use strict';

    const animateInclusionsTable = () => {
        const tables = document.querySelectorAll('.inclusions-table__table');
        
        tables.forEach((table) => {
            // Animate thead
            const thead = table.querySelector('thead');
            if (thead) {
                gsap.set(thead, {
                    opacity: 0,
                    y: 30,
                });

                ScrollTrigger.create({
                    trigger: thead,
                    start: "top 95%",
                    onEnter: () => {
                        gsap.to(thead, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            ease: "power2.out",
                        });
                    }
                });
            }

            // Animate each tbody row
            const tbodyRows = table.querySelectorAll('tbody tr');
            if (tbodyRows.length > 0) {
                gsap.set(tbodyRows, {
                    opacity: 0,
                    y: 30,
                });

                ScrollTrigger.batch(tbodyRows, {
                    start: "top 95%",
                    end: "bottom 20%",
                    onEnter: (rows) => {
                        gsap.to(rows, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            stagger: 0.15,
                            ease: "power2.out",
                        });
                    },
                });
            }

            // Animate tfoot
            const tfoot = table.querySelector('tfoot');
            if (tfoot) {
                gsap.set(tfoot, {
                    opacity: 0,
                    y: 30,
                });

                ScrollTrigger.create({
                    trigger: tfoot,
                    start: "top 95%",
                    onEnter: () => {
                        gsap.to(tfoot, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            delay: 0.2, // Slight delay after tbody rows
                            ease: "power2.out",
                        });
                    }
                });
            }
        });
    };

    // Wait for GSAP and ScrollTrigger to be available
    const waitForGSAP = () => {
        return new Promise((resolve) => {
            if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                resolve();
            } else {
                const checkGSAP = setInterval(() => {
                    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                        clearInterval(checkGSAP);
                        resolve();
                    }
                }, 100);
            }
        });
    };

    // Initialize animations when everything is ready
    const initAnimations = () => {
        waitForGSAP().then(() => {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', animateInclusionsTable);
            } else {
                animateInclusionsTable();
            }
        });
    };

    initAnimations();

})();